import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { environment } from "../../environments/environment";
import { PoTableColumn } from "@po-ui/ng-components";

const auth = environment.authorization;

@Injectable({
  providedIn: "root",
})
export class FinanceiroService {
  urlSeguimentos = `${environment.API}seguimentos`;
  urlFinanceiro = `${environment.API_PROTHEUS}consultafinanceira`;
  headers = new HttpHeaders({ authorization: sessionStorage.getItem("token") });
  headers2 = new HttpHeaders({'authorization':auth, 'tenantid':'01,0301', 'x-erp-module':'FAT', 'Accept-Charset':'UTF-8'});

  constructor(private http: HttpClient) {}

  getSeguimentos(coduser, portal): Observable<any> {
    return this.http.post(
      this.urlSeguimentos,
      { coduser, portal },
      { headers: this.headers }
    );
  }

  geraExcel(headers: string[], data: any[], vencidosHeaders: string[], vencidosData: any[]) {
    const url = `${environment.API}financeiroExcel`;
    const payload = { headers, data, vencidosHeaders, vencidosData };
    
    return this.http.post(url, payload, { headers: this.headers, responseType: 'blob' });
  }

  getTitulos(Cliente: String): Observable<any> {
    let empresa = sessionStorage.getItem("empresa");  
    return this.http.get(
      this.urlFinanceiro + "/?dados=" + Cliente + "&emp=" + empresa,
      { headers: this.headers2 }
    );
  }

  getColumns(): Promise<Array<PoTableColumn>> {
    return new Promise((resolve) => {
      const columns: Array<PoTableColumn> = [
        { property: "empresa", label: "Empresa", width: "20%" },
        { property: "numero", label: "Título", width: "12%" },
        { property: "parcela", label: "Parcela", width: "8%" },
        {
          property: "vencimento",
          label: "Vencimento",
          type: "date",
          format: "dd/MM/yyyy",
          width: "10%",
        },
        {
          property: "valor",
          label: "Valor",
          width: "30%",
        },
      ];
      resolve(columns);
    });
  }
  
}
